import { lazy, useCallback } from 'react';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { Stack, Typography, Button as MuiButton } from '@mui/material';
import { Modal } from '@client/components/globals/Modal';
import { getSelectedProfile } from '@client/selectors/helpers/profile';
import { Center } from '@client/components/common/Center';
import { getSessionUserState } from '@client/selectors/helpers/login';
import { openSignupModal } from '@client/components/Main/Signup';
import { Loader } from '@client/components/common/Loader';
import { useSelector } from '../redux.hooks';
import type { CachedLocation } from '@sda/utils/location/interfaces';

const VetProfileModalLoader = lazy(() => import('@client/components/routes/Connect/common/VetProfileModal'));

export const useCreateShowCallLink = (center?: CachedLocation) => {
  const userState = useSelector(getSessionUserState);

  const {
    description, compiledAddress, publicImageUrl, id,
    isVetted,
  } = useSelector(getSelectedProfile) || {};

  const handleMissingImageClick = useCallback(() => {
    Modal.show({
      backgroundColor: 'primary',
      title: ' ',
      buttons: [],
      body: (
        <Center>
          <Stack spacing={3}>
            <Stack spacing={2}>
              <Typography
                variant="h6"
                align="center"
              >
                Almost there!
              </Typography>

              <Typography
                variant="subtitle2"
                align="center"
              >
                {id ? 'In order to create a Show Call, you need to complete your profile.' : 'In order to create a Show Call, you need to create a profile.'}
              </Typography>
            </Stack>

            <MuiButton
              id="sda-show-call-complete-profile-button"
              aria-label="complete profile"
              variant="contained"
              color="primary"
              size="large"
              component={Link}
              to={id ? '/showcalls/profile' : '/signup/intent'}
            >
              {id ? 'Complete My Profile' : 'Create My Profile'}
            </MuiButton>
          </Stack>
        </Center>
      ),
    });
  }, [id]);

  const handleVetProfileClick = useCallback(() => {
    Modal.show({
      backgroundColor: 'primary',
      title: ' ',
      buttons: [],
      body: (
        <Loader load={VetProfileModalLoader} />
      ),
    });
  }, []);

  if (!userState) {
    return {
      onClick: () => openSignupModal(),
    };
  }

  if (isEmpty(publicImageUrl) || isEmpty(compiledAddress) || isEmpty(description)) {
    return {
      onClick: handleMissingImageClick,
    };
  }

  if (!isVetted) {
    return {
      onClick: handleVetProfileClick,
    };
  }

  let to = '/showcalls/create';

  if (center) {
    to = `/showcalls/create?l=${btoa(JSON.stringify(center))}`;
  }

  return {
    to,
    component: Link,
  };
};
